import "./es.array.is-array-7a29277f.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.assign-7e79fd7b.js";
import D, { createContext as F, useState as E, useCallback as U, useContext as K, useRef as q, useEffect as G } from "react";
import f from "styled-components";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.object.entries-d2a19275.js";
import "./es.object.to-string-f55666a8.js";
import "./es.string.replace-f4cc3aea.js";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as J } from "./getMetrics-953aa4f8.js";
import { jsx as _, jsxs as x } from "react/jsx-runtime";
import { fordProIcons as Q } from "@ucl/shared-icons";
import { useAccessibilityProps as O } from "./accessibility.js";
var k = /* @__PURE__ */ F({}), X = function(l) {
  var e = l.children, o = l.boxVariation, t = E(null), i = t[0], c = t[1], r = U(function(u) {
    c(function(m) {
      return m === u ? null : u;
    });
  }, []), a = {
    openItemId: i,
    handleItemClick: r,
    isParentBoxVariation: o
  };
  return /* @__PURE__ */ _(k.Provider, {
    value: a,
    children: e
  });
}, Y = /* @__PURE__ */ f.div.withConfig({
  displayName: "tableAccordion__AccordionContainer",
  componentId: "sc-1fafhbq-0"
})(["", ""], function(n) {
  var l, e, o, t, i;
  return `
    width: ` + ((l = n.theme) == null || (l = l.components) == null || (l = l.tableAccordion) == null || (l = l.AccordionContainer) == null ? void 0 : l.width) + `;
    display: ` + ((e = n.theme) == null || (e = e.components) == null || (e = e.tableAccordion) == null || (e = e.AccordionContainer) == null ? void 0 : e.display) + `;
    flex-direction: ` + ((o = n.theme) == null || (o = o.components) == null || (o = o.tableAccordion) == null || (o = o.AccordionContainer) == null ? void 0 : o.flexDirection) + `;
    gap: ` + (n.boxVariation ? (t = n.theme) == null || (t = t.components) == null || (t = t.tableAccordion) == null || (t = t.AccordionContainer) == null ? void 0 : t.gap.boxVariation : (i = n.theme) == null || (i = i.components) == null || (i = i.tableAccordion) == null || (i = i.AccordionContainer) == null ? void 0 : i.gap.default) + `;
  `;
}), Z = "ACCORDION_DATA_TEST_ID", Tn = function(l) {
  var e = l.children, o = e === void 0 ? [] : e, t = l.boxVariation, i = t === void 0 ? !1 : t, c = l.singleSelect, r = l.className, a = l.containerId, u = l.dataTestId, m = u === void 0 ? Z : u, h = Array.isArray(o) ? o : [o], p = J({
    label: "Accordion"
  });
  return /* @__PURE__ */ _(X, {
    boxVariation: i,
    children: /* @__PURE__ */ _(Y, Object.assign({
      id: a,
      dataTestId: m,
      className: r,
      singleSelect: c,
      boxVariation: i
    }, p, {
      children: h.map(function(d, s) {
        return d ? /* @__PURE__ */ D.cloneElement(d, {
          singleSelect: c,
          id: d.props.id,
          title: d.props.title,
          subTitle: d.props.subTitle,
          icon: d.props.icon,
          boxVariation: d.props.boxVariation,
          className: d.props.className,
          dataTestId: d.props.dataTestId,
          children: d.props.children,
          disabled: d.props.disabled,
          key: s
        }) : null;
      })
    }))
  });
}, nn = Q.CaretUp, ln = /* @__PURE__ */ f.div.withConfig({
  displayName: "tableAccordionItem__AccordionItemWrapper",
  componentId: "sc-1yidph9-0"
})(["", ""], function(n) {
  var l, e, o, t, i, c, r, a, u, m, h, p, d, s, v, b, A;
  return `
    display: ` + (n == null || (l = n.theme) == null || (l = l.components) == null || (l = l.tableAccordion) == null || (l = l.AccordionItemWrapper) == null ? void 0 : l.display) + `;
    flex-direction: ` + (n == null || (e = n.theme) == null || (e = e.components) == null || (e = e.tableAccordion) == null || (e = e.AccordionItemWrapper) == null ? void 0 : e.flexDirection) + `;
    border-bottom: ` + (n == null || (o = n.theme) == null || (o = o.components) == null || (o = o.tableAccordion) == null || (o = o.AccordionItemWrapper) == null ? void 0 : o.borderBottom) + `;
    background: ` + (n.disabled && n.boxVariation ? n == null || (t = n.theme) == null || (t = t.components) == null || (t = t.tableAccordion) == null || (t = t.AccordionItemWrapper) == null ? void 0 : t.background.boxVariationDisabled : n == null || (i = n.theme) == null || (i = i.components) == null || (i = i.tableAccordion) == null || (i = i.AccordionItemWrapper) == null ? void 0 : i.background.default) + `;

    &:hover {
      border-bottom: ` + (n.disabled ? n == null || (c = n.theme) == null || (c = c.components) == null || (c = c.tableAccordion) == null || (c = c.AccordionItemWrapper) == null ? void 0 : c.hover.borderBottomDisabled : n == null || (r = n.theme) == null || (r = r.components) == null || (r = r.tableAccordion) == null || (r = r.AccordionItemWrapper) == null ? void 0 : r.hover.borderBottomDefault) + `;
    }
    &:focus-visible {
      outline: ` + (n == null || (a = n.theme) == null || (a = a.components) == null || (a = a.tableAccordion) == null || (a = a.AccordionItemWrapper) == null ? void 0 : a.focusVisible.outline) + `;
      border-bottom: ` + (n == null || (u = n.theme) == null || (u = u.components) == null || (u = u.tableAccordion) == null || (u = u.AccordionItemWrapper) == null ? void 0 : u.focusVisible.borderBottom) + `;
    }

    ` + (n.boxVariation && `
        border-radius: ` + (n == null || (m = n.theme) == null || (m = m.components) == null || (m = m.tableAccordion) == null || (m = m.AccordionItemWrapper) == null ? void 0 : m.boxVariation.borderRadius) + `;
        outline: ` + (n == null || (h = n.theme) == null || (h = h.components) == null || (h = h.tableAccordion) == null || (h = h.AccordionItemWrapper) == null ? void 0 : h.boxVariation.outline) + `;
        border-bottom:` + (n == null || (p = n.theme) == null || (p = p.components) == null || (p = p.tableAccordion) == null || (p = p.AccordionItemWrapper) == null ? void 0 : p.boxVariation.borderBottom) + `;

        &:hover {
          outline: 
          ` + (n.disabled ? n == null || (d = n.theme) == null || (d = d.components) == null || (d = d.tableAccordion) == null || (d = d.AccordionItemWrapper) == null || (d = d.boxVariation) == null || (d = d.hover) == null ? void 0 : d.outlineDisabled : n == null || (s = n.theme) == null || (s = s.components) == null || (s = s.tableAccordion) == null || (s = s.AccordionItemWrapper) == null || (s = s.boxVariation) == null || (s = s.hover) == null ? void 0 : s.outlineDefault) + `;
          border-bottom:` + (n == null || (v = n.theme) == null || (v = v.components) == null || (v = v.tableAccordion) == null || (v = v.AccordionItemWrapper) == null ? void 0 : v.boxVariation.hover.borderBottom) + `
        }
        &:focus-visible {
          outline:  ` + (n == null || (b = n.theme) == null || (b = b.components) == null || (b = b.tableAccordion) == null || (b = b.AccordionItemWrapper) == null ? void 0 : b.boxVariation.focusVisible.outline) + `;
          border-bottom:` + (n == null || (A = n.theme) == null || (A = A.components) == null || (A = A.tableAccordion) == null || (A = A.AccordionItemWrapper) == null ? void 0 : A.boxVariation.focusVisible.borderBottom) + `;
  `) + `
  `;
}), en = /* @__PURE__ */ f.button.withConfig({
  displayName: "tableAccordionItem__HeaderWrapper",
  componentId: "sc-1yidph9-1"
})(["", ""], function(n) {
  var l, e, o, t, i, c, r, a, u, m, h, p;
  return `
    display: ` + (n == null || (l = n.theme) == null || (l = l.components) == null || (l = l.tableAccordion) == null || (l = l.HeaderWrapper) == null ? void 0 : l.display) + `;
    padding: ` + (n == null || (e = n.theme) == null || (e = e.components) == null || (e = e.tableAccordion) == null || (e = e.HeaderWrapper) == null ? void 0 : e.padding) + `;
    flex-direction: ` + (n == null || (o = n.theme) == null || (o = o.components) == null || (o = o.tableAccordion) == null || (o = o.HeaderWrapper) == null ? void 0 : o.flexDirection) + `;
    align-items: ` + (n.$isDropDownMenu ? n == null || (t = n.theme) == null || (t = t.components) == null || (t = t.tableAccordion) == null || (t = t.HeaderWrapper) == null ? void 0 : t.alignItems.isDropDownMenu : n == null || (i = n.theme) == null || (i = i.components) == null || (i = i.tableAccordion) == null || (i = i.HeaderWrapper) == null ? void 0 : i.alignItems.default) + `;
    gap: ` + (n == null || (c = n.theme) == null || (c = c.components) == null || (c = c.tableAccordion) == null || (c = c.HeaderWrapper) == null ? void 0 : c.gap) + `;
    align-self: ` + (n == null || (r = n.theme) == null || (r = r.components) == null || (r = r.tableAccordion) == null || (r = r.HeaderWrapper) == null ? void 0 : r.alignSelf) + `;
    cursor: ` + (n.disabled ? n == null || (a = n.theme) == null || (a = a.components) == null || (a = a.tableAccordion) == null || (a = a.HeaderWrapper) == null ? void 0 : a.cursor.disabled : n == null || (u = n.theme) == null || (u = u.components) == null || (u = u.tableAccordion) == null || (u = u.HeaderWrapper) == null ? void 0 : u.cursor.default) + `;

    background: ` + (n.disabled && n.boxVariation ? n == null || (m = n.theme) == null || (m = m.components) == null || (m = m.tableAccordion) == null || (m = m.HeaderWrapper) == null ? void 0 : m.background.boxVariationDisabled : n == null || (h = n.theme) == null || (h = h.components) == null || (h = h.tableAccordion) == null || (h = h.HeaderWrapper) == null ? void 0 : h.background.default) + `;
    border: ` + (n == null || (p = n.theme) == null || (p = p.components) == null || (p = p.tableAccordion) == null || (p = p.HeaderWrapper) == null ? void 0 : p.border) + `;
  `;
}), on = /* @__PURE__ */ f.div.withConfig({
  displayName: "tableAccordionItem__HeaderContentWrapper",
  componentId: "sc-1yidph9-2"
})(["", ""], function(n) {
  var l, e, o, t, i;
  return `
    display: ` + (n == null || (l = n.theme) == null || (l = l.components) == null || (l = l.tableAccordion) == null || (l = l.HeaderContentWrapper) == null ? void 0 : l.display) + `;
    flex-direction: ` + (n == null || (e = n.theme) == null || (e = e.components) == null || (e = e.tableAccordion) == null || (e = e.HeaderContentWrapper) == null ? void 0 : e.flexDirection) + `;
    align-items: ` + (n == null || (o = n.theme) == null || (o = o.components) == null || (o = o.tableAccordion) == null || (o = o.HeaderContentWrapper) == null ? void 0 : o.alignItems) + `;
    gap: ` + (n == null || (t = n.theme) == null || (t = t.components) == null || (t = t.tableAccordion) == null || (t = t.HeaderContentWrapper) == null ? void 0 : t.gap) + `;
    flex: ` + (n == null || (i = n.theme) == null || (i = i.components) == null || (i = i.tableAccordion) == null || (i = i.HeaderContentWrapper) == null ? void 0 : i.flex) + `;
  `;
}), tn = /* @__PURE__ */ f.div.withConfig({
  displayName: "tableAccordionItem__TitleWrapper",
  componentId: "sc-1yidph9-3"
})(["", ""], function(n) {
  var l, e, o, t, i, c, r;
  return `
    color: ` + (n.disabled ? n == null || (l = n.theme) == null || (l = l.components) == null || (l = l.tableAccordion) == null || (l = l.TitleWrapper) == null ? void 0 : l.color.disabled : n == null || (e = n.theme) == null || (e = e.components) == null || (e = e.tableAccordion) == null || (e = e.TitleWrapper) == null ? void 0 : e.color.default) + `;

    font-family: ` + (n == null || (o = n.theme) == null || (o = o.components) == null || (o = o.tableAccordion) == null || (o = o.TitleWrapper) == null ? void 0 : o.fontFamily) + `;
    font-size: ` + (n == null || (t = n.theme) == null || (t = t.components) == null || (t = t.tableAccordion) == null || (t = t.TitleWrapper) == null ? void 0 : t.fontSize) + `;
    font-style: ` + (n == null || (i = n.theme) == null || (i = i.components) == null || (i = i.tableAccordion) == null || (i = i.TitleWrapper) == null ? void 0 : i.fontStyle) + `;
    font-weight: ` + (n == null || (c = n.theme) == null || (c = c.components) == null || (c = c.tableAccordion) == null || (c = c.TitleWrapper) == null ? void 0 : c.fontWeight) + `;
    line-height: ` + (n == null || (r = n.theme) == null || (r = r.components) == null || (r = r.tableAccordion) == null || (r = r.TitleWrapper) == null ? void 0 : r.lineHeight) + `;
  `;
}), cn = /* @__PURE__ */ f.div.withConfig({
  displayName: "tableAccordionItem__SubtitleWrapper",
  componentId: "sc-1yidph9-4"
})(["", ""], function(n) {
  var l, e, o, t, i, c, r;
  return `
    color: ` + (n.disabled ? n == null || (l = n.theme) == null || (l = l.components) == null || (l = l.tableAccordion) == null || (l = l.SubtitleWrapper) == null ? void 0 : l.color.disabled : n == null || (e = n.theme) == null || (e = e.components) == null || (e = e.tableAccordion) == null || (e = e.SubtitleWrapper) == null ? void 0 : e.color.default) + `;
    font-family: ` + (n == null || (o = n.theme) == null || (o = o.components) == null || (o = o.tableAccordion) == null || (o = o.SubtitleWrapper) == null ? void 0 : o.fontFamily) + `;
    font-size: ` + (n == null || (t = n.theme) == null || (t = t.components) == null || (t = t.tableAccordion) == null || (t = t.SubtitleWrapper) == null ? void 0 : t.fontSize) + `;
    font-style: ` + (n == null || (i = n.theme) == null || (i = i.components) == null || (i = i.tableAccordion) == null || (i = i.SubtitleWrapper) == null ? void 0 : i.fontStyle) + `;
    font-weight: ` + (n == null || (c = n.theme) == null || (c = c.components) == null || (c = c.tableAccordion) == null || (c = c.SubtitleWrapper) == null ? void 0 : c.fontWeight) + `;
    line-height: ` + (n == null || (r = n.theme) == null || (r = r.components) == null || (r = r.tableAccordion) == null || (r = r.SubtitleWrapper) == null ? void 0 : r.lineHeight) + `;
  `;
}), rn = /* @__PURE__ */ f.div.withConfig({
  displayName: "tableAccordionItem__LeadingIconWrapper",
  componentId: "sc-1yidph9-5"
})(["", ""], function(n) {
  var l, e, o, t, i, c, r, a;
  return `
    display: ` + (n == null || (l = n.theme) == null || (l = l.components) == null || (l = l.tableAccordion) == null || (l = l.LeadingIconWrapper) == null ? void 0 : l.display) + `;
    min-height: ` + (n == null || (e = n.theme) == null || (e = e.components) == null || (e = e.tableAccordion) == null || (e = e.LeadingIconWrapper) == null ? void 0 : e.minHeight) + `;
    justify-content: ` + (n == null || (o = n.theme) == null || (o = o.components) == null || (o = o.tableAccordion) == null || (o = o.LeadingIconWrapper) == null ? void 0 : o.justifyContent) + `;
    align-items: ` + (n == null || (t = n.theme) == null || (t = t.components) == null || (t = t.tableAccordion) == null || (t = t.LeadingIconWrapper) == null ? void 0 : t.alignItems) + `;

    svg,
    img {
      width: ` + (n == null || (i = n.theme) == null || (i = i.components) == null || (i = i.tableAccordion) == null || (i = i.LeadingIconWrapper) == null ? void 0 : i.svg.width) + `;
      height: ` + (n == null || (c = n.theme) == null || (c = c.components) == null || (c = c.tableAccordion) == null || (c = c.LeadingIconWrapper) == null ? void 0 : c.svg.height) + `;
      color: ` + (n.disabled ? n == null || (r = n.theme) == null || (r = r.components) == null || (r = r.tableAccordion) == null || (r = r.LeadingIconWrapper) == null ? void 0 : r.svg.color.disabled : n == null || (a = n.theme) == null || (a = a.components) == null || (a = a.tableAccordion) == null || (a = a.LeadingIconWrapper) == null ? void 0 : a.svg.color.default) + `;
    }
  `;
}), an = /* @__PURE__ */ f.span.withConfig({
  displayName: "tableAccordionItem__ToggleIconWrapper",
  componentId: "sc-1yidph9-6"
})(["", ""], function(n) {
  var l, e, o, t, i, c, r;
  return `
    display: ` + (n == null || (l = n.theme) == null || (l = l.components) == null || (l = l.tableAccordion) == null || (l = l.ToggleIconWrapper) == null ? void 0 : l.display) + `;
    width: ` + (n == null || (e = n.theme) == null || (e = e.components) == null || (e = e.tableAccordion) == null || (e = e.ToggleIconWrapper) == null ? void 0 : e.width) + `;
    height: ` + (n == null || (o = n.theme) == null || (o = o.components) == null || (o = o.tableAccordion) == null || (o = o.ToggleIconWrapper) == null ? void 0 : o.height) + `;
    justify-content: ` + (n == null || (t = n.theme) == null || (t = t.components) == null || (t = t.tableAccordion) == null || (t = t.ToggleIconWrapper) == null ? void 0 : t.justifyContent) + `;
    align-items: ` + (n == null || (i = n.theme) == null || (i = i.components) == null || (i = i.tableAccordion) == null || (i = i.ToggleIconWrapper) == null ? void 0 : i.alignItems) + `;
    transform: rotate(` + (n.isAccordionOpen ? "0deg" : "-180deg") + `);
    transition: transform ` + (n.$isAnimate ? "0.3s" : "0s") + ` ease-in-out;

    svg,
    img {
      color: ` + (n.disabled ? n == null || (c = n.theme) == null || (c = c.components) == null || (c = c.tableAccordion) == null || (c = c.ToggleIconWrapper) == null ? void 0 : c.svg.color.disabled : n == null || (r = n.theme) == null || (r = r.components) == null || (r = r.tableAccordion) == null || (r = r.ToggleIconWrapper) == null ? void 0 : r.svg.color.default) + `;
    }
  `;
}), un = /* @__PURE__ */ f.div.withConfig({
  displayName: "tableAccordionItem__ContentWrapper",
  componentId: "sc-1yidph9-7"
})(["", ""], function(n) {
  var l, e, o, t, i, c;
  return `
    ` + (n.$isAnimate ? `
        height: ` + (n.accordionOpen ? n.$wrapperHeight + "px" : n == null || (l = n.theme) == null || (l = l.components) == null || (l = l.tableAccordion) == null || (l = l.ContentWrapper) == null ? void 0 : l.animate.defaultHeight) + `;
        overflow: ` + (n == null || (e = n.theme) == null || (e = e.components) == null || (e = e.tableAccordion) == null || (e = e.ContentWrapper) == null ? void 0 : e.animate.overflow) + `;
        transition: ` + (n == null || (o = n.theme) == null || (o = o.components) == null || (o = o.tableAccordion) == null || (o = o.ContentWrapper) == null ? void 0 : o.animate.transition) + `;
      ` : `
        display: ` + (n.accordionOpen ? n == null || (t = n.theme) == null || (t = t.components) == null || (t = t.tableAccordion) == null || (t = t.ContentWrapper) == null ? void 0 : t.display.accordionOpen : n == null || (i = n.theme) == null || (i = i.components) == null || (i = i.tableAccordion) == null || (i = i.ContentWrapper) == null ? void 0 : i.display.default) + `;
      `) + `
    padding: ` + (n == null || (c = n.theme) == null || (c = c.components) == null || (c = c.tableAccordion) == null || (c = c.ContentWrapper) == null ? void 0 : c.padding) + `
  `;
}), dn = /* @__PURE__ */ f.div.withConfig({
  displayName: "tableAccordionItem__AccordionItemEnd",
  componentId: "sc-1yidph9-8"
})(["", ""], function(n) {
  var l, e, o, t, i, c;
  return `
    display: ` + (n == null || (l = n.theme) == null || (l = l.components) == null || (l = l.tableAccordion) == null || (l = l.AccordionItemEnd) == null ? void 0 : l.display) + `;
    flex-direction: ` + (n == null || (e = n.theme) == null || (e = e.components) == null || (e = e.tableAccordion) == null || (e = e.AccordionItemEnd) == null ? void 0 : e.flexDirection) + `;
    justify-content: ` + (n == null || (o = n.theme) == null || (o = o.components) == null || (o = o.tableAccordion) == null || (o = o.AccordionItemEnd) == null ? void 0 : o.justifyContent) + `;
    align-items: ` + (n.$isDropDownMenu ? n == null || (t = n.theme) == null || (t = t.components) == null || (t = t.tableAccordion) == null || (t = t.AccordionItemEnd) == null ? void 0 : t.alignItems.dropdownMenu : n == null || (i = n.theme) == null || (i = i.components) == null || (i = i.tableAccordion) == null || (i = i.AccordionItemEnd) == null ? void 0 : i.alignItems.default) + `;
    gap: ` + (n == null || (c = n.theme) == null || (c = c.components) == null || (c = c.tableAccordion) == null || (c = c.AccordionItemEnd) == null ? void 0 : c.gap) + `;
  `;
}), mn = "ACCORDION_ITEM_DATA_TEST_ID", wn = function(l) {
  var e, o = l.children, t = l.title, i = l.subTitle, c = l.id, r = l.icon, a = l.boxVariation, u = l.disabled, m = l.className, h = l.dataTestId, p = h === void 0 ? mn : h, d = l.isIconOnClickEnabled, s = d === void 0 ? !0 : d, v = l.isDropDownMenu, b = v === void 0 ? !1 : v, A = l.DropDownComponent, T = l.isAnimate, C = T === void 0 ? !0 : T, w = l.accessibilityOptions, N = w === void 0 ? {} : w, H = K(k), L = H.openItemId;
  H.handleItemClick;
  var j = L === c, V = E(!1), g = V[0], S = V[1], I = q(null), M = O("button", Object.assign({}, N, {
    ariaExpanded: g,
    ariaControls: "accordion-content-" + c,
    ariaDisabled: u || !1,
    tabIndex: -1
  })), P = O("region", {
    ariaLabelledBy: "accordion-header-" + c,
    ariaHidden: !g
  });
  G(function() {
    I.current && g && C && (I.current.style.maxHeight = I.current.scrollHeight + "px");
  }, [g, C]);
  var $ = function() {
    g ? R() : B();
  }, B = function() {
    S(!0);
  }, R = D.useCallback(function() {
    S(!1);
  }, []), z = function(y) {
    (y.code === "Enter" || y.code === "Space") && (y.preventDefault(), $());
  };
  return /* @__PURE__ */ x(ln, {
    tabIndex: u ? -1 : 0,
    onKeyDown: z,
    accordionOpen: g,
    disabled: u,
    boxVariation: a,
    children: [/* @__PURE__ */ x(en, Object.assign({
      id: "accordion-header-" + c,
      "data-testid": p,
      boxVariation: a,
      disabled: u,
      className: m,
      onClick: !u && !/* @__PURE__ */ D.isValidElement(A) ? $ : void 0,
      accordionOpen: g,
      $isDropDownMenu: b
    }, M, {
      children: [r && /* @__PURE__ */ _(rn, {
        "data-component": "accordion-icon-wrapper",
        disabled: u,
        onClick: function(y) {
          s && $(), y.stopPropagation();
        },
        children: r
      }), /* @__PURE__ */ x(on, {
        onClick: function() {
          $();
        },
        children: [/* @__PURE__ */ _(tn, {
          disabled: u,
          "data-component": "accordion-title-wrapper",
          children: t
        }), i && /* @__PURE__ */ _(cn, {
          disabled: u,
          children: i
        })]
      }), /* @__PURE__ */ x(dn, {
        $isDropDownMenu: b,
        children: [/* @__PURE__ */ _(an, {
          onClick: function() {
            $();
          },
          "data-component": "accordion-dropdown-wrapper",
          icon: r,
          disabled: u,
          role: "button",
          isAccordionOpen: g,
          $isAnimate: C,
          children: /* @__PURE__ */ _(nn, {
            "aria-hidden": !1
          })
        }), b && A || null]
      })]
    })), /* @__PURE__ */ _(un, Object.assign({
      accordionOpen: g,
      isSingleSelectOpen: j,
      "aria-labelledby": "accordion-header-" + c,
      id: "accordion-content-" + c,
      "aria-hidden": !g,
      ref: I,
      $wrapperHeight: I == null || (e = I.current) == null ? void 0 : e.scrollHeight,
      $isAnimate: C,
      role: "region"
    }, P, {
      children: o
    }))]
  });
};
export {
  wn as A,
  Tn as T
};
